import React, { useMemo } from "react";
import * as actions from "../../store/actions";
import { connect } from "react-redux";
import { MenuItem, Select } from "@mui/material";
import { withStyles } from "tss-react/mui";
import productenStyle from "../../assets/jss/material-dashboard-pro-react/views/productStyle";
import { convertArrayToSelectOptions } from "../../templateHelpers";
import countryList from "react-select-country-list";

function CountryFilter(props) {
  const { classes } = props;
  const countryOptions = useMemo(() => countryList().getData(), []);
  const countryListProvider = [
    {
      value: "0",
      label: "All countries",
    },
    ...countryOptions,
  ];

  return (
    <Select
      MenuProps={{
        className: classes.selectMenu,
      }}
      classes={{
        select: classes.select,
      }}
      inputProps={{
        name: "simpleSelect",
        id: "simple-select",
        style: { paddingTop: "32px" },
      }}
      onChange={(e) => {
        let value = e.target.value;

        switch (value) {
          case "0":
            props.setFilter("country", null);
            break;
          case "NULL":
            props.setFilter("country", { field: "country", operator: null, value: null });
            break;
          default:
            props.setFilter("country", { field: "country", operator: "=", value: value });
            break;
        }
      }}
      style={{ backgroundColor: props.country === null ? null : "#ff9800" }}
      value={props.country?.value ? props.country.value : props.country == null ? "0" : "NULL"}
    >
      {countryListProvider.map((item) => (
        <MenuItem
          classes={{
            root: classes.selectMenuItem,
            selected: classes.selectMenuItemSelected,
          }}
          key={item.value}
          value={item.value}
        >
          {item.label}
        </MenuItem>
      ))}
    </Select>
  );
}

const mapStateToProps = (state) => ({
  ["country"]: state.filtersV2["country"],
});

const mapDispatchToProps = (dispatch) => ({
  setFilter: (key, filter) => {
    dispatch({
      type: actions.SET_FILTER,
      payload: { key, filter },
    });
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(CountryFilter, productenStyle));
